import { numberToCurrency } from "@components/utils/formatters";
import type {
  RedemptionDetails,
  ReinvestmentDetails,
  TimelineItemType,
} from "@interfaces/investment";

import React from "react";
import * as Popover from "@radix-ui/react-popover";

import * as Styled from "./Styled";

type Props = {
  type: TimelineItemType;
  details: RedemptionDetails | ReinvestmentDetails;
};

type Row = { label: string; value: string };

export const TimelineItemDetails: React.FC<Props> = ({ type, details }) => {
  const rowsByType: Partial<Record<TimelineItemType, Row[]>> = {};

  if (type === "redemption") {
    const {
      investment_period,
      aliquot,
      gross_value,
      income_tax,
      net_value,
      remaining_value,
    } = details as RedemptionDetails;

    rowsByType.redemption = [
      investment_period !== undefined && {
        label: "Período investido",
        value: `${investment_period} dias`,
      },
      aliquot !== undefined && {
        label: "Alíquota",
        value: `${aliquot.toFixed(1).replace(".", ",")}%`,
      },
      gross_value !== undefined && {
        label: "Valor bruto",
        value: numberToCurrency(gross_value),
      },
      income_tax !== undefined && {
        label: "Imposto de renda",
        value: numberToCurrency(income_tax),
      },
      { label: "Valor líquido", value: numberToCurrency(net_value) },
      { label: "Valor restante", value: numberToCurrency(remaining_value) },
    ].filter(Boolean) as Row[];
  }

  if (type === "reinvestment") {
    const { investment_value_at_date, reinvested_value } =
      details as ReinvestmentDetails;

    rowsByType.reinvestment = [
      {
        label: "Investimento na data",
        value: numberToCurrency(investment_value_at_date),
      },
      reinvested_value !== undefined && {
        label: "Valor reinvestido",
        value: numberToCurrency(reinvested_value),
      },
    ].filter(Boolean) as Row[];
  }

  const rows = rowsByType[type] ?? [];

  return (
    <Popover.Root>
      <Styled.DetailsPopoverTrigger>Ver detalhes</Styled.DetailsPopoverTrigger>

      <Popover.Portal>
        <Styled.DetailsPopoverContent>
          <Styled.DetailsTable>
            {rows.map(({ label, value }) => (
              <Styled.DetailsRow key={label}>
                <Styled.DetailsLabel>{label}</Styled.DetailsLabel>
                <Styled.DetailsValue>{value}</Styled.DetailsValue>
              </Styled.DetailsRow>
            ))}
          </Styled.DetailsTable>
        </Styled.DetailsPopoverContent>
      </Popover.Portal>
    </Popover.Root>
  );
};
